module.exports = __webpack_public_path__ + "static/media/privacyRule.ccca8ac5.png";